// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectUser_wrapper__4tXuc","searchInput":"SelectUser_searchInput__QCbgx","selectUser":"SelectUser_selectUser__KJaJ-"};